import useBusinessMessageSummary from "../../../../hooks/use-business-message-summary";
import StatCard from "../../../../components/StatCard";
import { StatSummary } from "../../../../components/StatSummary";
import { MessageIcon } from "../../../../shared/icons";

const BusinessMessageSummary = () => {
    const messageSummary = useBusinessMessageSummary();

    if (!messageSummary) {
        return null;
    }

    const todayTotal = messageSummary.todayTotal ?? 0;
    const currentMonthTotal = messageSummary.currentMonthTotal ?? 0;
    const currentYearTotal = messageSummary.currentYearTotal ?? 0;
    const lastMonthTotal = messageSummary.lastMonthTotal ?? 0;

    return (
        <div>
            <StatSummary>
                <StatCard title={`Today`} value={todayTotal.toLocaleString()} icon={MessageIcon} />
                <StatCard title={`This Month`} value={currentMonthTotal.toLocaleString()} icon={MessageIcon} />
                <StatCard title={`This Year`} value={currentYearTotal.toLocaleString()} icon={MessageIcon} />
                <StatCard title={`Last Month`} value={lastMonthTotal.toLocaleString()} icon={MessageIcon} />
            </StatSummary>
            {/* <Grid container direction="row" justifyContent="flex-start">
                <Grid item lg={5} md={6} sm={12} xs={12}>
                    <ChartCard><SingleBarChart data={messageSummary.monthlyTotals.map(item => { return { name: item.key, value: item.value } })} label={`Monthly Income (${CURRENCY})`} height={204} xAxisAngle={-90} /></ChartCard>
                </Grid>
                <Grid item lg={3} md={6} sm={12} xs={12}>
                    <ChartCard><DoughnutChart data={messageSummary.totalByBusinessship.map(item => { return { name: item.key, value: item.value } })} label='Income by Businessship' /></ChartCard>
                </Grid>
            </Grid> */}
        </div>
    )
}

export default BusinessMessageSummary;